import React from "react";

const Fun = () => (
  <div className="h-screen flex justify-center items-center bg-[#141414]">
    <h1 className="text-6xl font-sono text-white animate-pulse">
      Incoming!
    </h1>
  </div>
);

export default Fun;
